// extracted by mini-css-extract-plugin
export var asterix = "index-module--asterix--RR6j-";
export var banner = "index-module--banner--rsPiu";
export var bannerD = "index-module--bannerD--5qV1n";
export var block = "index-module--block--kNsdX";
export var blockText = "index-module--blockText--XlT5l";
export var bold = "index-module--bold--VpqAy";
export var card = "index-module--card--N2OcC";
export var carousel = "index-module--carousel--ePNGL";
export var carouselPic = "index-module--carouselPic--wwB7S";
export var color = "index-module--color--ZDZ4+";
export var controlsPic = "index-module--controlsPic--zuFbr";
export var dentistry = "index-module--dentistry--ezk5O";
export var description = "index-module--description--pnhUK";
export var downloadButton = "index-module--downloadButton--XzJqx";
export var duoPic = "index-module--duoPic--rmzAs";
export var grasLien = "index-module--grasLien--Cm5fs";
export var grasNoir = "index-module--grasNoir--QcJ0L";
export var grasRouge = "index-module--grasRouge--XyXOc";
export var homeTitle = "index-module--homeTitle--b5lEv";
export var hotel = "index-module--hotel--Liej+";
export var icon = "index-module--icon--cD24n";
export var ideal = "index-module--ideal--eycgN";
export var imageD = "index-module--imageD--23OMh";
export var imageGolf = "index-module--imageGolf--cZTu2";
export var imageGolfD = "index-module--imageGolfD--iUNLg";
export var imageWelcome = "index-module--imageWelcome---iUaa";
export var imageWelcomeD = "index-module--imageWelcomeD--8m3+X";
export var join = "index-module--join---bS3K";
export var link = "index-module--link--6529W";
export var normal = "index-module--normal--5eTBT";
export var posButton = "index-module--posButton--gai7N";
export var price = "index-module--price--cTULK";
export var prices = "index-module--prices--ASFaz";
export var programme = "index-module--programme--N1WMY";
export var question = "index-module--question--JrOGs";
export var resort = "index-module--resort--ZhVBG";
export var section = "index-module--section--ec5MD";
export var sectionFive = "index-module--sectionFive--2UIJB";
export var sectionFour = "index-module--sectionFour--d4bHw";
export var sectionHeigt = "index-module--sectionHeigt--W+vfA";
export var sectionNine = "index-module--sectionNine--+Dgn1";
export var sectionOne = "index-module--sectionOne--wXDT1";
export var sectionSeven = "index-module--sectionSeven--eepIQ";
export var sectionSix = "index-module--sectionSix--jYDH4";
export var sectionThree = "index-module--sectionThree--WLY-R";
export var sectionTwo = "index-module--sectionTwo--rDn29";
export var speciale = "index-module--speciale--3yYU+";
export var subgroup = "index-module--subgroup--Grtfq";
export var subtitle = "index-module--subtitle--jvEJV";
export var textPrice = "index-module--textPrice--PqzbF";
export var title = "index-module--title--oUmHu";
export var triCard = "index-module--triCard--ZgqfO";
export var view = "index-module--view--o6Ooq";
export var workshop = "index-module--workshop--WOBEr";